// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__oTdod","footer":"ModalUpdate_footer__2Nrh7"};